import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4c4eb42f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4c4eb42f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4eb42f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c4eb42f')) {
      api.createRecord('4c4eb42f', component.options)
    } else {
      api.reload('4c4eb42f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4c4eb42f&scoped=true&", function () {
      api.rerender('4c4eb42f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/truth/index.vue"
export default component.exports